const MediaQueries = {
	phone: '@media only screen and (max-width: 600px)'
}

export default MediaQueries;